// Module
var code = "<p>You can give us permission to release account information to individuals you authorize. Although they can receive specific information about your loans, they <strong>cannot</strong> make changes to your account. </p> <p class=\"center\"><strong>To authorize a third party to obtain your account information:</strong></p> ";
// Exports
export default code;